'use client';

import { useContext } from 'react';
import { Context } from '@context/PreferenceContext';

import Article from '@components/Article/Article';
import Button from '@components/Button/Button';
import Description from '@components/Description/Description';
import Layout from '@components/Layout/Layout';
import Title from '@components/Title/Title';

type IndexProps = {
  body: string;
  featureFlags: any;
  siteTitle: string;
  title: string;
};

export default function Cookies({
  body,
  featureFlags,
  siteTitle,
  title,
}: IndexProps) {
  const context = useContext(Context)!;

  if (!context) {
    return null;
  }

  const { isCookieBarVisible, showCookieBar } = context;

  return (
    <Layout
      featureFlags={featureFlags}
      pageTitle={title}
      pageType="article"
      section="Home"
      siteTitle={siteTitle}
      url="/cookies"
    >
      <Article.ContentWrapper>
        <Title>{title}</Title>
        <Description content={body} />

        {!isCookieBarVisible ? (
          <Button
            analytics={{
              category: 'CookieBar',
              action: 'click',
              label: 'Open',
            }}
            onClick={() => showCookieBar()}
            text="Open Cookie Bar"
          />
        ) : (
          <p>
            Set your preferences in the cookie bar at the bottom of the screen.
          </p>
        )}
      </Article.ContentWrapper>
    </Layout>
  );
}
